import React from 'react';
import { createRoot } from 'react-dom/client';
import {
  AdminCouponDetailPage,
  type AdminCouponDetailPageProps,
} from '../ui/admin/AdminCouponDetailPage';

export function AdminCouponDetailPageContainer(props: AdminCouponDetailPageProps) {
  return <AdminCouponDetailPage {...props} />;
}

export function mountAdminCouponDetailPage(
  container: HTMLElement,
  props: AdminCouponDetailPageProps
) {
  const root = createRoot(container);
  root.render(<AdminCouponDetailPageContainer {...props} />);
  return root;
}

export default AdminCouponDetailPageContainer;
